import LayoutContainer from "../../components/Containers/LayoutContainer";
import KahootChallengeData from "./KahootQuizData";

const Kahoot_Challenge = () => {
  return (
    <LayoutContainer title="Kahoot Challenge">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Kahoot Challenge Data
        </h2>
      </div>
      <KahootChallengeData />
    </LayoutContainer>
  );
};

export default Kahoot_Challenge;
